export type SortDirection = 'asc' | 'desc';

export interface SortState {
  column: string;
  direction: SortDirection;
}

export function getNextSort(current: SortState, column: string): SortState {
  if (current.column !== column) {
    return { column, direction: 'asc' };
  }

  if (current.direction === 'asc') {
    return { column, direction: 'desc' };
  }

  return { column: '', direction: 'asc' };
}